import React from "react";
import style from "../../Styles/Components/ProductCard.module.css";
import { dateUtil } from '../../Lib/Utils';
import Logo from "../Logo";

const ProductCard = ({ item, locale, handleConfirmDetail }) => (
  <div className={style.container} onClick={handleConfirmDetail}>
    <div className={style.logoContainer}>
        <Logo imgSrc={item.logoUrl}></Logo>
    </div>
    <div className={style.infoContainer}>
      <span className={style.infoTitle}>
        {locale === 'en' ? 'Company Name' : ''}
        {locale === 'kr' ? '브랜드사명' : ''}
        {locale === 'cn' ? '制造商' : ''}
      </span>
      <span className={style.infoDescription}>{item[locale + 'CompanyName']}</span>
    </div>
    <div className={style.infoContainer}>
      <span className={style.infoTitle}>
        {locale === 'en' ? 'Product Name' : ''}
        {locale === 'kr' ? '제품명' : ''}
        {locale === 'cn' ? '产品名' : ''}
      </span>
      <span className={style.infoDescription}>{item[locale + 'ProductName']}</span>
    </div>
    <div className={style.recentAuthContainer}>
      <span className={style.recentAuthTitle}>
        {locale === 'en' ? 'Date/Time' : ''}
        {locale === 'kr' ? '최근 인증시간' : ''}
        {locale === 'cn' ? '最新验证时间' : ''}
      </span>
      <span className={style.recentAuthTime}>{dateUtil.format('custom', new Date(item.createdAt))}</span>
    </div>
  </div>
);

export default ProductCard;
